<div class="container-fluid">
  <div class="row">
    <div class="alignMenu shadow text-left pt-2 px-1" [ngClass]="companyId == 36 ? 'col-md-3 col-lg-2' : 'col-lg-2 col-xl-2'">
      <app-rental-menu (companyIdSevenMile)="companyIdSevenMile($event)"></app-rental-menu>
    </div>
    <div class="bgMainSection bgBlue text-left" [ngClass]="companyId == 36 ? 'col-md-9 col-lg-10' : 'col-lg-10 col-xl-10'">
      <div class="container mainContainer">
        <div class="row">
          <div class="col-5 text-left mt-4">
            <h2 class="mainHeading">Contact Us</h2>
          </div>
          <div class="col-7 text-right mt-4" [ngClass]="{'col-lg-5': SwapORamaCustomChanges}">
            <h1 class="mainHeading">{{marketName}}</h1>
          </div>
          <div class="col-12 col-lg-2 text-left text-lg-right mt-4" *ngIf="SwapORamaCustomChanges">
            <a class="text-white language-toggle translator" style="text-decoration: none !important;" translate="no" href="javascript:void(0)" onclick="toggleLanguage()">Español</a>
          </div>
        </div>
        <div class="bgWghite shadow pt-2 mt-2">
          <div class="container">
            <form [formGroup]="contactUsForm" (ngSubmit)="onSubmit()">
              <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-start mt-3">
                  <label class="mb-0" for="name">Name:</label>
                  <input type="text" id="name" class="form-control" formControlName="name">
                  <small style="color: #D7232C;" *ngIf="contactUsForm.get('name').hasError('required')" i18n>* required </small>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-start mt-3">
                  <label class="mb-0" for="PhoneNo">Phone:</label>
                  <ejs-maskedtextbox id="PhoneNo" name="telephone" [mask]="PhoneNumberMask" formControlName="phone" tabindex="0">
                  </ejs-maskedtextbox>
                  <small style="color: #D7232C;" *ngIf="contactUsForm.get('phone').hasError('minlength')" i18n>* invalid</small>
                  <small style="color: #D7232C;" *ngIf="contactUsForm.get('phone').hasError('required')" i18n>* required </small>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-start mt-3">
                  <label class="mb-0" for="email">E-Mail:</label>
                  <input type="email" id="email" class="form-control" formControlName="email">
                  <small style="color: #D7232C;" *ngIf="contactUsForm.get('email').hasError('required')" i18n>* required </small>
                  <small style="color: #D7232C;" *ngIf="contactUsForm.get('email').hasError('email')" i18n>* invalid </small>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-left mt-3">
                  <label class="mb-0" for="subject">Subject</label>
                  <input class="form-control" id="subject" formControlName="subject">
                  <small style="color: #D7232C;" *ngIf="contactUsForm.get('subject').hasError('required')" i18n>* required </small>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-left mt-3">
                  <label class="mb-0" for="comments">Comments</label>
                  <textarea class="form-control" id="comments" formControlName="comments"></textarea>
                  <small style="color: #D7232C;" *ngIf="contactUsForm.get('comments').hasError('required')" i18n>* required </small>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-8 col-md-8 col-lg-5 col-xl-5 text-left mt-3"
                  style="font-size: medium; font-weight: bold; display: flex;">
                  <label class="mb-0 mt-2" for="Validation"><span id="firstNum"></span> + <span id="secondNum"></span> =</label>
                  <input type="text" id="Validation" style="width: 23%; font-weight: bold;" class="form-control ml-2"
                    formControlName="captchaResult" (keydown)="validateCaptchaResult($event)" maxlength="4">
                  <i type="button" class="fas fa-refresh ml-2 mt-2" style="font-weight: bold;"
                    (click)="generateCaptcha()"></i>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-right mt-2 mb-3">
                  <button class="btn btn-outline-primary mr-1" type="button" (click)="resetForm()">Cancel</button>
                  <button class="btn btn-primary" type="submit">Submit</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>